




import { Vue, Component } from 'vue-property-decorator';

import SellCoinsV1 from './V1/SellCoins.vue';
import SellCoinsV2 from './V2/SellCoins.vue';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    SellCoinsV1,
    SellCoinsV2
  }
})
export default class SellCoins extends Vue {
  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isSellCoinsFlowActive() {
    return this.flags.includes(flagKeys.coinRevenueOverview);
  }

  get currentComponent() {
    if (!this.isSellCoinsFlowActive) {
      return 'SellCoinsV1';
    }

    return 'SellCoinsV2';
  }
}
